import client from "@irati/utils/services/apollo";
import teamPerksMetricsQuery from "./apollo/query/TeamPerksMetrics";
import perksMetricsQuery from "./apollo/query/PerksMetrics";
import perksGoMetricsQuery from "./apollo/query/PerksGoMetrics";
import platformMetricsQuery from "./apollo/query/PlatformMetrics";
var AdminService = /** @class */ (function () {
    function AdminService() {
        this.getTeamPerksMetrics = function (tenantId) {
            return client
                .query({ query: teamPerksMetricsQuery, variables: { tenantId: tenantId }, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.teamPerksMetrics;
            });
        };
        this.getPerksMetrics = function (tenantId) {
            return client
                .query({ query: perksMetricsQuery, variables: { tenantId: tenantId }, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.perksMetrics;
            });
        };
        this.getPerksGoMetrics = function (tenantId) {
            return client
                .query({ query: perksGoMetricsQuery, variables: { tenantId: tenantId }, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.perksGoMetrics;
            });
        };
        this.getPlatformMetrics = function (tenantId) {
            return client
                .query({ query: platformMetricsQuery, variables: { tenantId: tenantId }, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.platformMetrics;
            });
        };
    }
    return AdminService;
}());
export default new AdminService();
